import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			selectedImageIndex: undefined,
			facilityid: undefined,
			units: []
		};
	},
	// props: {
	// 	filter: Object,
	// 	sorting: String,
	// 	max: String
	// },
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}
		var unitgroup = this.getUnitGroupId(parseInt(this.$el.dataset.facilityid, 10));
		console.log("unitgroupid is==>" + unitgroup);

		var req = {
			fields: this.resultFields,
			filter: {
				unitgroupid: unitgroup
			},

			sorting: 'random'
		};

		this.doSearchNow(req);

	},


	updated: function () {
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();
	},
	methods: {
		doSearchNow: function (req) {
			console.log("req: ", req);
			doReq('searchUnits', req)
				.then((res) => {
					console.log("res:", res)
					this.units = res.units;
				});

		},
		getUnitGroupId: function (id) {
			if (id == '197176') {
				return 48854;
			}
			if (id == '197192') {
				return 48857;
			}
			if (id == '197210') {
				return 48856;
			}
			if (id == '197204') {
				return 45373;
			}
			if (id == '197169') {
				return 45375;
			}
			if (id == '197174') {
				return 45374;
			}
			if (id == '197168') {
				return 45371;
			}
			if (id == '197211') {
				return 48858;
			}
			if (id == '197166') {
				return 45372;
			}
			if (id == '197173') {
				return 48859;
			}
			return null;
		},
		getUnitSearchTarget: function (id) {
			if (window.screen.width < 768) {
				//probably phone?
				return '_self';
			} else {
				return 'unit_' + id;
			}
		},
	},
	filters: {
		formatfeedback: function (value) {
			if (!value) return '';
			if (Number.isInteger(value)) return value.toFixed();
			return (value.toFixed(1).replace('.', ','));
		}
	}

};